import { AlertCircleIcon, CheckCircleIcon, CircleXIcon } from "lucide-react"

import { Alert, AlertTitle } from "@/components/ui/alert"

import type { ApprovalRequest as LenderApprovalRequest } from "@boundless/bl-api-client/lender/models"
import type { ApprovalRequest as PartnerApprovalRequest } from "@boundless/bl-api-client/partners/models"

type ApprovalRequest = PartnerApprovalRequest | LenderApprovalRequest

export function ApprovalStatusAlert({
  approval,
}: {
  approval: ApprovalRequest
}) {
  const approvalMsg = (() => {
    switch (approval.status) {
      case "approved":
        return "Your changes were approved"
      case "pending":
        return "Changes are pending Boundless Approval"
      case "rejected":
        return "Your changes were declined. Reach out to kyle@getboundless.io"
      default:
        return ""
    }
  })()

  const alertVariant = (() => {
    switch (approval.status) {
      case "approved":
        return "success"
      case "pending":
        return "warning"
      case "rejected":
        return "destructive"
      default:
        return "default"
    }
  })()

  if (!approvalMsg) {
    return null
  }

  const icon = (() => {
    switch (approval.status) {
      case "approved":
        return <CheckCircleIcon />
      case "pending":
        return <AlertCircleIcon />
      case "rejected":
        return <CircleXIcon />
      default:
        return <AlertCircleIcon />
    }
  })()

  return (
    <Alert variant={alertVariant}>
      {icon}
      <AlertTitle>{approvalMsg}</AlertTitle>
    </Alert>
  )
}
